import styled, { css } from 'styled-components';
import { Container } from 'styles';

const tableAttrs = () => ({
  flex: true,
  padding: '16px',
});

const tableHeadStyles = css`
  background: ${props => props.theme.colors.background.tertiary};
`;

export const RecipientTableBody = styled(Container).attrs(tableAttrs)`
  > * {
    flex-grow: 1;
    flex-basis: 25%;
  }
`;

export const RecipientTableHead = styled(RecipientTableBody)`
  ${tableHeadStyles}
`;

export const LineItemsTableBody = styled(Container).attrs(tableAttrs)`
  padding: 0 16px 16px 0;

  h2 {
    font-size: 14px;
  }

  p {
    font-size: 12px;
    margin-left: 12px;
  }

  li:first-child {
    border-top: none;
    padding-top: 0;
  }

  > * {
    flex-grow: 1;
  }
`;

export const LineItemsTableHead = styled(Container).attrs(tableAttrs)`
  justify-content: space-between;
  margin-bottom: 16px;
  ${tableHeadStyles}
`;
